import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'perdaFlexivel'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos/${id}/perdas_flexiveis`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/perdas_flexiveis/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingPerdaFlexivelSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingPerdaFlexivelSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_PERDA_FLEXIVEL_SUCCESS = 'LOADING_PERDA_FLEXIVEL_SUCCESS'
export function loadingPerdaFlexivelSuccess(perdaFlexivel) {
  return {
    type: LOADING_PERDA_FLEXIVEL_SUCCESS,
    perdaFlexivel,
  }
}

export const DESTROYING_PERDA_FLEXIVEL_SUCCESS = 'DESTROYING_PERDA_FLEXIVEL_SUCCESS'
export function destroyingPerdaFlexivelSuccess(perdaFlexivelId) {
  return {
    type: DESTROYING_PERDA_FLEXIVEL_SUCCESS,
    perdaFlexivelId,
  }
}

export function fetchMultiplePerdaFlexivel(parentId, params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.INDEX, parentId) + toQueryString(params)
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchPerdaFlexivel(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createPerdaFlexivel(parentId, perdaFlexivel) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.CREATE, parentId), 'POST', perdaFlexivel).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updatePerdaFlexivel(id, perdaFlexivel) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', perdaFlexivel).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyPerdaFlexivel(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const perdaFlexivel = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_PERDA_FLEXIVEL_SUCCESS: {
      const { perdaFlexivel: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_PERDA_FLEXIVEL_SUCCESS:
      return state.delete(action.perdaFlexivelId.toString())

    default:
      return state
  }
}

export default perdaFlexivel
